<template>
  <div>
    <div class="filter-bar">
      <span @click="selectYear">
        年份 {{ year }}
        <i class="caret"></i>
      </span>
      <span>
        {{ querytype }}
        <i class="caret"></i>
        <select
          class="filter-item__select"
          v-model="querytype"
          @change="searchPurcSaleMonth"
        >
          <option :value="'全部'">全部</option>
          <option :value="'按工作中心'">按工作中心</option>
        </select>
      </span>
    </div>

    <div class="canvas-box">
      <canvas id="myChart" class="myChart"></canvas>
    </div>

    <div class="list-box" v-if="querytype == '全部' && result.monthitems">
      <div class="list-box-col">
        <p class="list-box-col__title">月份</p>
        <p
          class="list-box-col__content"
          v-for="item in result.monthitems"
          :key="item.text"
        >
          {{ item.text }}
        </p>
      </div>
      <div
        class="list-box-col list-box-active"
        @click="initChart(deal2(result.details[0]))"
      >
        <p class="list-box-col__title">完工率%</p>
        <p
          class="list-box-col__content"
          style="color: #2eadf5"
          v-for="item in result.monthitems"
          :key="item.text"
        >
          {{ numberFormat(item.amount, "#,##0.##") || 0 }}
        </p>
      </div>
      <div
        class="list-box-col list-box-active"
        @click="initChart(deal2(result.details[1]))"
      >
        <p class="list-box-col__title">直通率%</p>
        <p
          class="list-box-col__content"
          style="color: #e44959"
          v-for="item in result.monthitems"
          :key="item.text"
        >
          {{ numberFormat(item.direct, "#,##0.##") || 0 }}
        </p>
      </div>
      <div
        class="list-box-col list-box-active"
        @click="initChart(deal2(result.details[2]))"
      >
        <p class="list-box-col__title">损耗率%</p>
        <p
          class="list-box-col__content"
          style="color: #16b603"
          v-for="item in result.monthitems"
          :key="item.text"
        >
          {{ numberFormat(item.loss, "#,##0.##") || 0 }}
        </p>
      </div>
      <div
        class="list-box-col list-box-active"
        @click="initChart(deal2(result.details[3]))"
      >
        <p class="list-box-col__title">未完工工单</p>
        <p
          class="list-box-col__content"
          style="color: #000"
          v-for="item in result.monthitems"
          :key="item.text"
        >
          {{ numberFormat(item.unmade, "#,##0.##") || 0 }}
        </p>
      </div>
    </div>

    <div
      class="list-box list-container"
      v-if="querytype !== '全部' && result.monthitems"
    >
      <div class="list-fixed">
        <p class="list-box-col__title">月份</p>
        <p
          class="list-box-col__content"
          v-for="item in result.monthitems"
          :key="item.text"
        >
          {{ item.text }}
        </p>
      </div>
      <div class="list-scroll">
        <div class="list-scroll-wrap">
          <div
            class="list-box-col list-box-active"
            v-for="wc in result.details"
            :key="wc.wc_name"
            @click="initChart(deal2(wc))"
          >
            <p class="list-box-col__title">{{ wc.wc_name || "未命名" }}</p>
            <p class="list-box-col__content" v-for="month in 12" :key="month">
              {{ numberFormat(wc["amount" + month], "#,##0.##") || 0 }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import F2 from '@antv/f2'
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  data() {
    return {
      year: new Date().getFullYear(),
      result: {},
      querytype: "全部",
      querytypeObj: {
        全部: "all",
        按工作中心: "workcenter",
      },
      opened: -1,
      chart: null,
    };
  },
  mounted() {
    this.searchPurcSaleMonth();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    searchPurcSaleMonth() {
      let me = this;

      const params = {
        year: me.year,
        querytype: me.querytypeObj[me.querytype],
      };
      me.$ajax({
        url: "/api/make/report/makeInAnalysis",
        params,
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          me.initChart(me.deal(me.result.monthitems));
        }
      });
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.deal(this.result.monthitems));
      }
    },
    initChart(data) {
      var chart = this.chart;
      if (chart) {
        chart.changeData(data);
        return;
      }
      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });

      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 12 : 6,
          formatter: (i) =>
            i > -1 && i < 12
              ? [
                  "01月",
                  "02月",
                  "03月",
                  "04月",
                  "05月",
                  "06月",
                  "07月",
                  "08月",
                  "09月",
                  "10月",
                  "11月",
                  "12月",
                ][i]
              : null,
        },
      });

      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "完工率%") {
            return "#2eadf5";
          } else if (val === "直通率%") {
            return "#e44959";
          } else if (val === "损耗率%") {
            return "#16b603";
          } else if (val === "未完工工单") {
            return "#000";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.05, // 设置分组间柱子的间距
        });
      if (window.innerWidth < window.innerHeight) {
        // 定义进度条
        chart.scrollBar({
          mode: "x",
          xStyle: {
            backgroundColor: "#e8e8e8",
            fillerColor: "#808080",
            offsetY: -2,
          },
        });
      }

      chart.interaction("pan");
      chart.render();
    },
    deal(data) {
      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: "完工率%", value: 0 },
        { index: 12, type: "完工率%", value: 0 },
      ];
      data.forEach((item, i) => {
        arr.push(
          {
            text: item.text,
            type: "完工率%",
            index: i,
            value: item.amount || 0,
          },
          {
            text: item.text,
            type: "直通率%",
            index: i,
            value: item.direct || 0,
          },
          {
            text: item.text,
            type: "损耗率%",
            index: i,
            value: item.loss || 0,
          },
          {
            text: item.text,
            type: "未完工工单",
            index: i,
            value: item.unmade || 0,
          }
        );
      });
      const l = arr.length / 3;
      if (l < 12) {
        for (let i = l; i < 12; i++) {
          arr.push(
            {
              index: i,
              text: textArr[i],
              type: "完工率%",
              value: 0,
            },
            {
              index: i,
              text: textArr[i],
              type: "直通率%",
              value: 0,
            },
            {
              index: i,
              text: textArr[i],
              type: "损耗率%",
              value: 0,
            },
            {
              index: i,
              text: textArr[i],
              type: "未完工工单",
              value: 0,
            }
          );
        }
      }
      return arr;
    },
    deal2(data) {
      if (!data) return;
      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: data.text, value: 0 },
        { index: 12, type: data.text, value: 0 },
      ];
      for (let i = 0; i < 12; i++) {
        arr.push({
          index: i,
          text: textArr[i],
          type: data.text,
          value: data["amount" + (i + 1)] || 0,
        });
      }
      return arr;
    },
    selectYear() {
      var me = this,
        year = new Date().getFullYear(),
        years = [];
      for (let i = year - 20; i <= year; i++) {
        years.push({
          value: i,
          label: i + "年",
        });
      }
      me.$weui.picker(years, {
        title: "选择年份",
        defaultValue: [year],
        onConfirm: function (r) {
          me.year = r[0].value;
          me.searchPurcSaleMonth();
        },
      });
    },
    open(index) {
      if (index != this.opened)
        this.initChart(this.deal2(this.result.details[index]));

      this.opened = index == this.opened ? -1 : index;
    },
    getMonth(month) {
      return month < 10 ? "0" + month : month;
    },
  },
};
</script>

<style scoped>
.canvas-box {
  /* width: 100%;
  height: 100%; */
  overflow-x: scroll;
  background: var(--weui-BG);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.list-box-col {
  text-align: center;
}
.list-box-col p {
  line-height: 40px;
}
.list-box-col__title {
  font-weight: bold;
}
.list-box-col__content {
  font-size: small;
  color: var(--weui-FG-0);
}
.list-box-active:active {
  background-color: #e0e0e0;
}
.list-container {
  text-align: center;
  line-height: 40px;
  background: var(--weui-BG);
  display: flex;
}
.list-fixed {
  width: 100px;
  border-right: 1px solid var(--weui-FG-3);
}
.list-scroll {
  flex-grow: 1;
  overflow-y: scroll;
}

.list-scroll-wrap {
  width: 180%;
  display: flex;
  justify-content: space-around;
}
.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
  position: relative;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}
@media screen and (min-width: 500px) {
  .filter-bar {
    padding: 6px 0 2px 0;
  }
  .list-scroll-wrap {
    width: 100%;
  }
  .list-box-col p {
    line-height: 25px;
  }
  .list-container{
    line-height: 25px;
  }
}
</style>